<div
  class="col-md-12 noBottomMargin noPaddingMd-12 mainLoginDiv"
  *ngIf="showLoginForm"
>
  <img width="100%" src="assets/images/ppm/login_background.jpg" />
  <div class="col-md-12 outer-cover-login">
    <div class="col-md-4"></div>
    <div
      class="col-md-4 outer-cover-login-form noPaddingMd-12"
      id="whiteBackground"
    >
      <div
        class="alert alert-danger logincustomError"
        *ngIf="authenticationError"
      >
        {{ "login.messages.error.authentication" | translate }}
      </div>
      <div class="alert alert-danger logincustomError" *ngIf="userLocked">
        {{ "login.messages.error.userlock" | translate }}
      </div>
      <div class="alert alert-danger logincustomError" *ngIf="userNotRegistered">
        {{ "login.form.userNotRegistered" | translate }}
      </div>
      <!-- NOTE : Disable it due to user concern -->
      <!-- <div class="alert alert-danger logincustomError" *ngIf="passwordExpired">
          {{'login.messages.error.passwordexpired' | translate}}
        </div> -->
      <div class="loginFormDiv">
        <h4 class="centerHeader">
          {{ "global.loginwelcome" | translate }} <br />
          eAZy {{ "global.pension" | translate }}
        </h4>
        <form
          class="form loginForm"
          role="form"
          (submit)="login()"
          style="display: flex; flex-direction: column; padding: 2%"
        >
          <div class="login-form-group pmi_form_group">
            <input
              type="text"
              id="username"
              name="username"
              [(ngModel)]="username"
              autocomplete="off"
              autofocus
              required
            />
            <!--
              <span class="highlight"></span>
-->
            <span class="bar"></span>
            <label>{{ "global.form.certificatenumber" | translate }}</label>
          </div>
          <div class="login-form-group pmi_form_group">
            <input
              type="password"
              id="password"
              name="password"
              [(ngModel)]="password"
              autocomplete="off"
              autofocus
              required
            />
            <!--
              <span class="highlight"></span>
-->
            <span class="bar"></span>
            <label>{{ "login.form.password" | translate }}</label>
            <p class="forgotLink">
              <a class="forgotALink" [routerLink]="['/forgotpassword']">{{
                "global.form.forgotpassword" | translate
              }}</a>
            </p>
          </div>
          <div style="display: flex; justify-content: center">
            <button type="submit" class="btn btn-primary btn-block customBtn">
              {{ "login.form.button" | translate }}
              <span *ngIf="showSpinner"
                ><img
                  style="width: 20px"
                  src="../../../../../assets/images/spinner.gif"
                  alt=""
              /></span>
            </button>
          </div>
        </form>
        <p></p>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</div>

<bs-modal #otpModal [keyboard]="false">
  <bs-modal-body>
    <div>
      <h4 class="modal-text">{{ "mfa.loginVerification" | translate }}</h4>
      <p class="modal-text">{{ "mfa.deviceNotRegistered" | translate }}</p>
      <p class="modal-text">{{ "mfa.insert6Digit" | translate }}</p>
      <span class="modal-text">{{ otpUserEmail }}</span>
      <div>
        <form [formGroup]="form">
          <div class="otp-grid">
            <input
              (paste)="onPaste($event)"
              class="otp-input"
              formControlName="form1"
              type="tel"
              maxlength="1"
              id="form1"
              (keyup)="otpOnKeypress($event, 'form1', 'form2', '')"
              required
            />
            <input
              (paste)="onPaste($event)"
              class="otp-input"
              formControlName="form2"
              type="tel"
              maxlength="1"
              id="form2"
              (keyup)="otpOnKeypress($event, 'form2', 'form3', 'form1')"
              required
            />
            <input
              (paste)="onPaste($event)"
              class="otp-input"
              formControlName="form3"
              type="tel"
              maxlength="1"
              id="form3"
              (keyup)="otpOnKeypress($event, 'form3', 'form4', 'form2')"
              required
            />
            <input
              (paste)="onPaste($event)"
              class="otp-input"
              formControlName="form4"
              type="tel"
              maxlength="1"
              id="form4"
              (keyup)="otpOnKeypress($event, 'form4', 'form5', 'form3')"
              required
            />
            <input
              (paste)="onPaste($event)"
              class="otp-input"
              formControlName="form5"
              type="tel"
              maxlength="1"
              id="form5"
              (keyup)="otpOnKeypress($event, 'form5', 'form6', 'form4' )"
              required
            />
            <input
              (paste)="onPaste($event)"
              class="otp-input"
              formControlName="form6"
              type="tel"
              maxlength="1"
              id="form6"
              (keyup)="otpOnKeypress($event, 'form6', '', 'form5')"
              required
            />
          </div>
        </form>
      </div>

      <div style="padding-bottom: 10px; display: flex; justify-content: center">
        <small>{{ "mfa.otpValid15minutes" | translate }}</small>
      </div>

      <div style="padding-bottom: 10px; display: flex; justify-content: center">
        <small
          *ngIf="otpExceedMessage"
          class="d-flex justify-content-center text-danger pb-4"
        >
          {{ "mfa.exceedLimit" | translate }}
        </small>
        <small
          *ngIf="otpInvalidMessage"
          class="d-flex justify-content-center text-danger pb-4"
        >
          {{ "mfa.otpCodeInvalid" | translate }}
        </small>
      </div>

      <div  *ngIf="!loadingLogin"  style="display: flex; justify-content: center; gap: 10px">
        <button
          [disabled]="!form.valid"
          type="submit"
          class="btn btn-primary"
          (click)="loginVerficationButton()"
        >
          {{ "mfa.send" | translate }}
          <div class="spinner spinner-border"></div>
        </button>
        <button      *ngIf="!otpExceedMessage"     class="btn btn-warning"
          [disabled]="this.timeLeft >= 0 "
          (click)="resendOtp()"
        >
          {{ "mfa.resendOtp" | translate }}
          <span class="px-2" *ngIf="timeLeft > 0">
            {{ timeLeft }}
          </span>
        </button>
      </div>
      <div *ngIf="loadingLogin" style="display: flex; justify-content: center;">
        <img src="assets/images/loading.gif" style="width: 45px;"/>
      </div>
    </div>
  </bs-modal-body>
</bs-modal>